import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import cn from 'classnames';

import Button from '../Button';

import s from './RouteHint.module.css';

import { ReactComponent as InfoIcon } from 'icons/info.svg';

const RouteHint = ({ show, setShow, className, children, onConfirm, ...props }) => {
  const [t] = useTranslation();

  return (
    <Downshift isOpen={show} onOuterClick={() => setShow(false)}>
      {({ getMenuProps, isOpen }) => (
        <div className={cn(s.wrap, className)} {...props}>
          <div className={cn(s.root, { [s.opened]: show })}>
            <InfoIcon className={s.icon} onClick={() => setShow(true)} />
            {show && <div className={s.glue} />}
            {show && (
              <span
                {...getMenuProps({
                  className: cn(s.content, { [s.visible]: isOpen, [s.hidden]: !isOpen }),
                  onAnimationStart: ({ animationName }) => animationName === s.expanding,
                  onAnimationEnd: ({ animationName }) => animationName === s.collapsing,
                })}
              >
                {children}
                <Button
                  className={s.button}
                  theme="transparent"
                  fixedWidth={160}
                  center
                  onClick={() => {
                    setShow(false);
                    onConfirm && onConfirm();
                  }}
                >
                  {t('Понятно')}
                </Button>
              </span>
            )}
          </div>
        </div>
      )}
    </Downshift>
  );
};

RouteHint.propTypes = {
  className: PropTypes.string,
  onConfirm: PropTypes.func,
};

export default RouteHint;
